declare global {
  interface Window {
    _paq?: any[];
    _matomoInitialized?: boolean;
  }
}

const MATOMO_URL = process.env.REACT_APP_MATOMO_URL;
const SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;

// Matomo initialisieren
export function initMatomo() {
  // ------------------------------------------------------
  // If not in production, bail out immediately:
  // ------------------------------------------------------
  if (process.env.REACT_APP_RUN_ENV !== "production") {
    console.debug("[Matomo] Disabled in development mode.");
    return;
  }
  if (typeof window !== "undefined" && !window._matomoInitialized) {
    window._matomoInitialized = true;
    window._paq = window._paq || [];

    window._paq.push(["setExcludedQueryParams", ["DSID", "RestoreSearch"]]);
    window._paq.push(["setTrackerUrl", MATOMO_URL + "matomo.php"]);
    window._paq.push(["setSiteId", SITE_ID]);
    window._paq.push(["trackPageView"]);
    window._paq.push(["enableLinkTracking"]);

    console.log(" Matomo Tracking gestartet! (production).");

    // Matomo Skript dynamisch einfügen
    const d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = MATOMO_URL + "matomo.js";
    s.parentNode?.insertBefore(g, s);

    setTimeout(() => {
      console.log("Matomo _paq Wert:", window._paq); // Debugging
    }, 3000);
  } else {
    console.warn("Matomo wurde bereits geladen!");
  }
}

// Benutzeraktion tracken (z. B. Button-Klicks, Formulareingaben)
export function trackEvent(
  category: string,
  action: string,
  name?: string,
  value?: number
) {
  if (window._paq) {
    window._paq.push(["trackEvent", category, action, name || "", value || 0]);
    console.log(` Matomo Event: ${category} - ${action} - ${name} - ${value}`);
  } else {
    console.warn("Matomo ist noch nicht geladen.");
  }
}

// Benutzer-ID setzen (nach Login)
export function setUserId(userId: string) {
  if (window._paq) {
    window._paq.push(["setUserId", userId]);
    console.log(` Matomo User ID gesetzt: ${userId}`);
  }
}

// API-Requests tracken (z. B. erfolgreiche und fehlgeschlagene API-Anfragen)
export function trackApiRequest(endpoint: string, status: string) {
  if (window._paq) {
    window._paq.push(["trackEvent", "API Request", status, endpoint]);
  }
}


// Navigationstracking aktivieren (für Single-Page-Apps)
export function trackPageView() {
  if (window._paq) {
    window._paq.push(["setCustomUrl", window.location.href]);
    window._paq.push(["trackPageView"]);
    console.log(`Matomo: Seite getrackt -> ${window.location.href}`);
    //console.log(window._paq)
  } else {
    console.warn(" Matomo ist noch nicht geladen.");
  }
}
